import useStore, { WizardAnswersSelector, WizardIntegrationsSelector, WizardLanguagesSelector, WizardState } from '___store'
import { getOptionPropertiesFromAnswer } from '___store/storeSegments/wizard/typified/helpers'

import { Answers, Integrations, LanguageValue, OptionValueProperties } from '___types'

const compareDocumentAndWizardAnswers = (documentAnswers: Answers, wizardAnswers: WizardAnswersSelector): boolean => {
  if (documentAnswers.length !== wizardAnswers?.length) return true
  return Boolean(
    wizardAnswers.find((answer, index) => {
      const documentAnswer = documentAnswers[index]
      if (!documentAnswer || answer.id !== documentAnswer.id) return true
      const answerValueEntries = Object.entries(getOptionPropertiesFromAnswer(answer))
      const documentAnswerOptionProperties = getOptionPropertiesFromAnswer(documentAnswer)
      if (answerValueEntries.length !== Object.keys(documentAnswerOptionProperties).length) return true
      return answerValueEntries.find(([id, properties]) => {
        const relevantDocumentValue = documentAnswerOptionProperties[id]
        if (relevantDocumentValue === undefined || Object.keys(properties).length !== Object.keys(relevantDocumentValue).length) return true
        return Object.entries(properties).find(([key, value]) => relevantDocumentValue[key as keyof OptionValueProperties] !== value)
      })
    })
  )
}

export const isDocumentDirty = (
  wizardLanguages: WizardLanguagesSelector,
  wizardIntegrations: WizardIntegrationsSelector,
  wizardAnswers: WizardAnswersSelector,
  languages?: LanguageValue[],
  integrations?: Integrations,
  documentAnswers?: Answers
): boolean => (!documentAnswers ? true : compareDocumentAndWizardAnswers(documentAnswers, wizardAnswers)) // implement language and integrations checks

type UseStoreHookResultType = { wizardState: WizardState }

export const useIsDocumentDirty = (languages?: LanguageValue[], integrations?: Integrations, answers?: Answers) => {
  const {
    wizardState: { languages: wizardLanguages, integrations: wizardIntegrations, answers: wizardAnswers },
  } = useStore('selectWizardState') as UseStoreHookResultType
  return isDocumentDirty(wizardLanguages, wizardIntegrations, wizardAnswers, languages, integrations, answers)
}

export default useIsDocumentDirty
